import axios from 'axios';

export type THttpServiceConfig = {
  baseURL?: string;
  headers?: {
    region?: string;
    channel?: string;
    Accept?: string;
    Authorization?: string;
    'x-smiles-recsys'?: string;
  };
  credentials?: string;
};

export type THttpService = {
  get: (url: string, config?: THttpServiceConfig) => Promise<any>;
  post: (url: string, data?: any, config?: THttpServiceConfig) => Promise<any>;
};

export function HttpService(config: THttpServiceConfig) {
  return axios.create(config) as THttpService;
}
